<template>
  <div class="flex flex-col gap-5">
    <label class="text-lg font-bold">{{ title }}</label>
    <div class="flex flex-col border rounded-md">
      <div class="flex flex-col" v-for="index in 3" :key="index" v-if="loading">
        <div class="inline-flex items-center justify-between p-3">
          <div class="inline-flex items-center gap-2 w-full h-4">
            <USkeleton class="h-4 w-full"/>
          </div>
        </div>
        <UDivider class="h-2 w-full" v-if="index < items.length - 1"/>
      </div>
      <div class="flex flex-col" v-for="(item, index) in items" :key="index" @click="$emit('navigate', item.href)">
        <div class="inline-flex items-center justify-between p-3 gap-2">
          <div class="inline-flex items-center gap-1 w-full break-all line-clamp-1 text-sm h-4 text-nowrap">
            <span class="text-gray-500 text-nowrap">Search </span>
            <span class="text-nowrap">"{{ item.label }}"</span>
            <span class="text-gray-500 text-nowrap">{{ item.suffix }}</span>
          </div>
          <UIcon :name="item.icon" class="flex-shrink-0"/>
        </div>
        <UDivider class="h-2 w-full" v-if="index < items.length - 1"/>
      </div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  title: { type: String, required: true },
  items: { type: Array, required: true },
  loading: { type: Boolean, required: true }
});
</script>